import { useCallback, useEffect, useState } from 'react';

import {
    exitDocumentFullscreen,
    getFullscreenElement,
    requestDocumentFullscreen,
} from '@utils/fullscreen';

const MAP_VIEW = 'karta';

export function useMapImmersiveFullscreen(viewComp) {
    const [mapImmersive, setMapImmersive] = useState(false);

    useEffect(() => {
        if (viewComp !== MAP_VIEW) {
            setMapImmersive(false);
            exitDocumentFullscreen().catch(() => {});
        }
    }, [viewComp]);

    useEffect(() => {
        const onFullscreenChange = () => {
            if (viewComp !== MAP_VIEW) return;
            if (!getFullscreenElement()) {
                setMapImmersive(false);
            }
        };
        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
        };
    }, [viewComp]);

    const toggleMapImmersive = useCallback(() => {
        if (viewComp !== MAP_VIEW) return;
        const next = !mapImmersive;
        setMapImmersive(next);
        if (next) {
            requestDocumentFullscreen().catch(() => {});
        } else {
            exitDocumentFullscreen().catch(() => {});
        }
    }, [viewComp, mapImmersive]);

    return { mapImmersive, toggleMapImmersive };
}
